// extracted by mini-css-extract-plugin
export default {"wrapper":"_740ca597","image":"_dd5fd2a3"};